"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordCloudResults = void 0;
const utils_1 = require("../../../utils");
const lodash_1 = require("lodash");
const WordCloud_1 = require("./WordCloud");
var WordCloudResults;
(function (WordCloudResults) {
    function fromUserReferenceAndAnswer(entries) {
        const answerValues = (0, lodash_1.flatMap)(entries, (entry, index) => {
            return WordCloud_1.WordCloud.Answer.words(entry && entry.pinEntry && entry.pinEntry.answer).map((answer) => ({
                ...answer,
                user: entry.user, // TODO get real user id here
            }));
        });
        // group all values by the normalized values
        const groupedByStripped = (0, lodash_1.groupBy)(answerValues, (value) => value.normalized);
        const words = (0, lodash_1.map)(groupedByStripped, (values, key) => {
            const mostGivenAnswer = (0, utils_1.mostEncounteredValue)((0, lodash_1.map)(values, (value) => value.source));
            return {
                count: values.length,
                word: key,
                pretty: mostGivenAnswer || '',
                users: values.map((value) => value.user),
                variationCount: (0, lodash_1.size)((0, lodash_1.groupBy)(values)),
            };
        });
        return { words };
    }
    WordCloudResults.fromUserReferenceAndAnswer = fromUserReferenceAndAnswer;
})(WordCloudResults || (exports.WordCloudResults = WordCloudResults = {}));
//# sourceMappingURL=WordCloudResults.js.map